import FooterBottomBarLink from "./footer-bottom-bar-link/footer-bottom-bar-link-component";
export const linkComponentTypes = {
    FooterBottomBarLink
};
export default linkComponentTypes;
